// The morning brief's note (P4-05): Scout's few bullets, each account name opening its panel.
//
// Rendered from `lib/briefNote.ts` data, so every string goes through JSX and is escaped.

import type { NoteSegment } from '../lib/briefNote.ts';
import { parseBriefNote } from '../lib/briefNote.ts';

function Segments({
  segments,
  onOpenAccount,
}: {
  segments: NoteSegment[];
  onOpenAccount: (accountId: string) => void;
}) {
  return (
    <>
      {segments.map((segment, index) => {
        // Index keys are correct: segments are rebuilt wholesale from one string.
        if (segment.accountId) {
          const accountId = segment.accountId;
          return (
            <button key={index} type="button" className="briefnotelink" onClick={() => onOpenAccount(accountId)}>
              {segment.text}
            </button>
          );
        }
        return segment.bold ? <b key={index}>{segment.text}</b> : <span key={index}>{segment.text}</span>;
      })}
    </>
  );
}

export function BriefNote({
  body,
  onOpenAccount,
}: {
  body: string;
  onOpenAccount: (accountId: string) => void;
}) {
  const blocks = parseBriefNote(body);
  return (
    <div className="briefnote">
      {blocks.map((block, index) => {
        if (block.kind === 'bullet') {
          return (
            <ul key={index} className="briefnotelist">
              {block.items.map((item, itemIndex) => (
                <li key={itemIndex}><Segments segments={item} onOpenAccount={onOpenAccount} /></li>
              ))}
            </ul>
          );
        }
        const className = block.kind === 'heading' ? 'briefnotehead' : 'briefnotepara';
        return <p key={index} className={className}><Segments segments={block.segments} onOpenAccount={onOpenAccount} /></p>;
      })}
    </div>
  );
}
